import { api } from "./api";

const SESSION_HEADER = "X-Session-Token";

const withAuth = (token) => ({
  headers: { [SESSION_HEADER]: token },
});

export async function communityLogin(email) {
  const { data } = await api.post("/community/login", { email });
  return data;
}

export async function communityLogout(token) {
  if (!token) return { ok: true };
  try {
    const { data } = await api.post("/community/logout", {}, withAuth(token));
    return data;
  } catch (err) {
    console.error("communityLogout failed:", err);
    return { ok: false };
  }
}

export async function fetchMe(token) {
  const { data } = await api.get("/community/me", withAuth(token));
  return data;
}

export async function updateMe(token, body) {
  const { data } = await api.put("/community/me", body, withAuth(token));
  return data;
}

export async function fetchTopics() {
  const { data } = await api.get("/community/topics");
  return data?.topics || [];
}

export async function fetchPosts(token, topic = "all", limit = 30) {
  const params = { limit };
  if (topic && topic !== "all") params.topic = topic;
  const { data } = await api.get("/community/posts", {
    ...withAuth(token),
    params,
  });
  return data;
}

export async function createPost(token, body) {
  const { data } = await api.post("/community/posts", body, withAuth(token));
  return data;
}

export async function updatePost(token, postId, body) {
  const { data } = await api.put(
    `/community/posts/${postId}`,
    body,
    withAuth(token)
  );
  return data;
}

export async function deletePost(token, postId) {
  const { data } = await api.delete(`/community/posts/${postId}`, withAuth(token));
  return data;
}

export async function moderatorHidePost(token, postId, reason) {
  const { data } = await api.post(
    `/community/posts/${postId}/moderate-hide`,
    { reason: reason || "" },
    withAuth(token)
  );
  return data;
}

export async function fetchReplies(token, postId) {
  const { data } = await api.get(
    `/community/posts/${postId}/replies`,
    withAuth(token)
  );
  return data;
}

export async function createReply(token, postId, body) {
  const { data } = await api.post(
    `/community/posts/${postId}/replies`,
    body,
    withAuth(token)
  );
  return data;
}

export async function toggleReaction(token, postId, kind = "heard") {
  const { data } = await api.post(
    `/community/posts/${postId}/reaction`,
    { kind },
    withAuth(token)
  );
  return data;
}

// Admin endpoints
export async function adminListCommunityPosts(adminKey, { include_hidden = true, limit = 200 } = {}) {
  const { data } = await api.get("/admin/community/posts", {
    params: { admin_key: adminKey, include_hidden, limit },
  });
  return data;
}

export async function adminHidePost(adminKey, postId, reason) {
  const { data } = await api.post(
    `/admin/community/posts/${postId}/hide`,
    null,
    { params: { admin_key: adminKey, reason } }
  );
  return data;
}

export async function adminUnhidePost(adminKey, postId) {
  const { data } = await api.post(
    `/admin/community/posts/${postId}/unhide`,
    null,
    { params: { admin_key: adminKey } }
  );
  return data;
}

export async function adminDeletePost(adminKey, postId) {
  const { data } = await api.delete(`/admin/community/posts/${postId}`, {
    params: { admin_key: adminKey },
  });
  return data;
}
